import { FeatureFlag } from '../FeatureFlag';

/**
 * Loads symbol-key tables keys first and stitches their columns per visible symbol (ADR 0020,
 * DEC-ROLLOUT-001). Scope: Results, Search, Screener, Scanner, Watchlist, and Alpha Scans; today
 * only the Results widget, Alpha Scans included, reads it. The server table computes only
 * membership and order, and the widget's consumer-local column table serves every other visible
 * column. Market columns are meant to come
 * from shared per-symbol feed tables; until table-cpp-proxy's subscription cap changes, the column
 * table serves them too (DEC-TABLES-001). Read when a widget is created, so a change applies to
 * widgets created afterwards.
 */
export const enableStitchedSymbolTables = new FeatureFlag({
    key: 'enable-stitched-symbol-tables',
    defaultValue: false,
});
